import styled from "styled-components";

export const InvitationModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
export const InvitationModalTitle = styled.div`
  font-size: 16px;
  width: 80%;
  margin:  auto;
  text-align: center;
`;
export const InvitationModalContent = styled.div``;
export const InvitationModalAction = styled.div`
  display: flex;
  justify-content: flex-end;
`;
export const InvitationModalButton = styled.button`
  min-width: 100px;
  font-size: 16px;
`;